export default __webpack_public_path__ + "static/media/ElasticCache.cf24c1ff.svg";